<odx-modal-header>
  <odx-area-header>
    {{ modalTitle }}
    @if (subtitle$ | async; as subtitle) {
      @if (subtitle) {
        <odx-area-header-subtitle>{{ subtitle }}</odx-area-header-subtitle>
      }
    }
  </odx-area-header>
</odx-modal-header>
<odx-modal-content>
  @if (modalRef.data.productItems.length >= 1 || modalRef.data.attachments.length >= 1) {
    <div class="table-scroll-wrapper">
      <table odxTable [headerData]="headerData" [data]="(products$ | async) || []">
        <thead>
          <th></th>
        </thead>
        @for (d of products$ | async; track $index) {
          <tr odx-table-row>
            <td odx-table-cell>{{ d.quantity }}</td>
            <td odx-table-cell>{{ d.productName }}</td>
            <td odx-table-cell>{{ d.productId }}</td>
            @if (hasDetectionRange) {
              <td odx-table-cell>{{ d.detectionRange !== undefined ? d.detectionRange + " m" : "" }}</td>
            }
          </tr>
        }
      </table>
    </div>
  } @else {
    <p i18n="@@group.modal.attachments.noAttachments">Keine Sachnummern zum Anzeigen vorhanden</p>
  }
</odx-modal-content>
<odx-modal-footer>
  <button odxButton variant="primary" i18n="@@group.modal.button.close" (click)="onConfirm()">Schließen</button>
</odx-modal-footer>
